import React from 'react';
import { IIconProps } from './utils';

export const Toolbox = ({
  fill = 'currentColor',
  height = 18,
  width = 18,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 18 18" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5.96826 5.22314H3.72973C2.49343 5.22314 1.49121 6.22537 1.49121 7.46166V8.95402M5.96826 5.22314V4.47698C5.96826 3.65277 6.6364 2.98462 7.4606 2.98462H10.4453C11.2695 2.98462 11.9377 3.65277 11.9377 4.47698V5.22314M5.96826 5.22314H11.9377M1.49121 8.95402V12.6849C1.49121 13.9212 2.49343 14.9234 3.72973 14.9234H10.4453M1.49121 8.95402H2.98355H8.95296M11.9377 5.22314H14.1761C15.4125 5.22314 16.4147 6.22537 16.4147 7.46166V8.95402M16.4147 8.95402V12.6849C16.4147 13.9212 15.4125 14.9234 14.1761 14.9234H13.43M16.4147 8.95402H8.95296M8.95296 8.95402V8.20784M8.95296 8.95402V9.7002"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.49234"
    />
  </svg>
);
